import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef } from '@angular/material/dialog';
import { QRCodeModule } from 'angularx-qrcode';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { AppDownloadService } from '../../../services/app-download.service';

/**
 * Desktop-only companion to the profile row (app-download spec §2): she cannot
 * install from a desktop, so the row opens the code to scan plus both badges.
 * Closes on the X or on the backdrop.
 */
@Component({
  selector: 'app-download-dialog',
  standalone: true,
  imports: [CommonModule, QRCodeModule, TranslatePipe],
  template: `
    <div class="adl-dlg">
      <button
        type="button"
        class="adl-dlg-x"
        (click)="ref.close()"
        [attr.aria-label]="'resultDetail.close' | translate"
      >
        &times;
      </button>
      <h3 class="adl-dlg-title">{{ 'appDownload.title' | translate }}</h3>
      <p class="adl-dlg-sub">{{ 'appDownload.bodyDesktop' | translate }}</p>
      <p class="adl-dlg-note">{{ 'appDownload.signInNote' | translate }}</p>
      <div class="adl-dlg-qr">
        <qrcode
          [qrdata]="dl.qrUrl"
          [width]="168"
          [margin]="1"
          [errorCorrectionLevel]="'M'"
          [colorDark]="'#1a1a2e'"
          [colorLight]="'#ffffff'"
          [alt]="'appDownload.title' | translate"
        ></qrcode>
      </div>
      <div class="adl-dlg-badges">
        <a
          [href]="dl.storeUrl('ios')"
          target="_blank"
          rel="noopener"
          [attr.aria-label]="'appDownload.ariaAppStore' | translate"
        >
          <img [src]="dl.badgeSrc('ios')" alt="" class="adl-dlg-apple" />
        </a>
        <a
          [href]="dl.storeUrl('android')"
          target="_blank"
          rel="noopener"
          [attr.aria-label]="'appDownload.ariaGooglePlay' | translate"
        >
          <img [src]="dl.badgeSrc('android')" alt="" class="adl-dlg-play" />
        </a>
      </div>
    </div>
  `,
  styles: [
    `
      .adl-dlg {
        position: relative;
        padding: 22px 24px 20px;
        text-align: center;
      }
      .adl-dlg-x {
        position: absolute;
        top: 8px;
        inset-inline-end: 10px;
        width: 34px;
        height: 34px;
        border: 0;
        background: none;
        font-size: 26px;
        line-height: 1;
        color: #999;
        cursor: pointer;
        font-family: inherit;
      }
      .adl-dlg-title {
        font-size: 16px;
        font-weight: 800;
        color: var(--navy, #1a1a2e);
        margin: 0 0 6px;
      }
      .adl-dlg-sub {
        font-size: 12.5px;
        line-height: 1.6;
        color: #555;
        margin: 0 0 14px;
      }
      .adl-dlg-note {
        font-size: 12px;
        line-height: 1.6;
        color: #666;
        margin: -8px 0 14px;
      }
      .adl-dlg-qr {
        display: inline-block;
        padding: 8px;
        background: #fff;
        border: 1px solid #e4e4e8;
        border-radius: 10px;
        line-height: 0;
      }
      .adl-dlg-badges {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        margin-top: 14px;
        flex-wrap: wrap;
      }
      .adl-dlg-apple {
        height: 40px;
        width: auto;
        display: block;
      }
      .adl-dlg-play {
        height: 59px;
        width: auto;
        display: block;
      }
    `,
  ],
})
export class AppDownloadDialogComponent {
  constructor(
    public ref: MatDialogRef<AppDownloadDialogComponent>,
    public dl: AppDownloadService,
  ) {}
}
